import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

async function validateAccess(hasPermission: (authService: AuthService) => boolean): Promise<boolean> {
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.waitForInitialization();

  if (!authService.isAuthenticatedSync()) {
    router.navigate(['/login']);
    return false;
  }

  if (hasPermission(authService)) {
    return true;
  }

  router.navigate(['/eventos']);
  return false;
}

export const eventoDashboardGuard: CanActivateFn = async () => {
  return validateAccess((authService) => authService.canAccessEventoDashboard());
};

export const eventoInfoBasicaGuard: CanActivateFn = async () => {
  return validateAccess((authService) => authService.canAccessEventoInfoBasica());
};

export const eventoVentasGuard: CanActivateFn = async () => {
  return validateAccess((authService) => authService.canViewVentas());
};

export const eventoHistorialCarritosGuard: CanActivateFn = async () => {
  return validateAccess((authService) => authService.canViewHistorialCarritos());
};

export const eventoReportesGuard: CanActivateFn = async () => {
  return validateAccess((authService) => authService.canViewReportes());
};

export const eventoFuncionesGuard: CanActivateFn = async () => {
  return validateAccess((authService) => authService.canViewFunciones());
};

export const eventoGestionGuard: CanActivateFn = async () => {
  return validateAccess((authService) => authService.canGestionarEvento());
};
